import { Alert } from "element-ui";

/********************************************************************************************
 * FG - FOOF - After Cert - First Release (7) - First Release Security
 * I created this file to do the security checks for the first release
 * *****************************************************************************************/
export default {
  //aaaaaaa - FOR SECURITY - NEW SECURITY
  //The data returned from the server will be a string starting with "Restricted"
  //if the user is not allowed to even see the data.  
  //This convenience method makes code cleaner when checking for "Restricted" data
  isDataRestricted(data) {
    let stringToCheck = "";
    if(data != null) {
      if(typeof data === 'string') {
        stringToCheck = data;
      }
      else if(data.hasOwnProperty('responseText')) { 
        stringToCheck = data.responseText;
      }
    }
    return stringToCheck.startsWith("Hydroware - Restricted:")?stringToCheck:false;
    //return data !=null && typeof data === 'string' && data.startsWith("Hydroware - Restricted")
  },

  //elementIdentifier is the type of data being checked (i.e. incidents, personelljobinfo, etc)
  //action is what the signed on user is trying to do with the data (i.e. view, add, etc.)
  //when action is not specified the array of rules for the elementIdentifier is returned 
  //otherwise 
  //the rule for the specific action (a string) on that elementIdentifier is returned.
  getRule(elementIdentifier,action=null) {
    if(window.securityRules == null )                 return ""
    if (!(elementIdentifier in window.securityRules)) return ""
    var rule = window.securityRules[elementIdentifier]   
    if(action != null) return rule[action]; 
    else return rule
  },

  /**************************************************************************************
   * METHODS BELOW ARE SPECIFIC TO DOING SECURITY CHECKS FOR PERSONELL DATA             *
   **************************************************************************************/
  allow_P(rule,pid_employee,ordinance_employee) {
    //if(1==1) return true;
    var ordinance_SignedOnUser = authDetails.roleOrdinance;
    var pid_SignedOnUser       = authDetails.PersonnelId;
    //Personnel rules may be complex.  If so, then each rule within that complex set of rules
    //is separated by a semicolon. (i.e. 'O,LT', or '!O;Y')
    //In order to use "includes" to check on for values in both complex and single rules I
    //make sure there is a semicolon as the last character in the string that represents
    //the rule.
    if(rule.endsWith(";")==false) rule += ";";
    //var isComplexRule = rule.includes(";");
 
    //1) If the signed on user is accessing themself then check to be sure if
    //   a rule is in place to specifically allow/disallow that.
    //   If there is then that rule take precedence over all others.
    if(pid_SignedOnUser == pid_employee) {
      if(rule.includes('!O;')) return false;
      if(rule.includes('O;'))  return true;
    }

    //2) if we get here then either the signed on user is not accessing themself
    //   OR there is no specific rule in place for accessing onesself
    //   We now check rules in the following order
    //   a) if the rule contains an 'N' we disallow
    //   b) if the rule contains a  'Y' we allow
    //   c) if the rule contains    'LT' and the role ordinance value of the signed on user 
    //                               is less than that of the employee being accessed then
    //                               we allow (higher ordinance value means lesser role, i.e.
    //                               AquaticsDirector is ord: 2, PoolManager: 3, ... Office Staff: 7)
    //   d) if the rule contains    'LE' and the role ordinance value of the signed on user
    //                              is less than or equal to the role ordinance of employee being 
    //                              accessed then we allow (higher ordinance value means lesser role, 
    //                              i.e. AquaticsDirector is ord: 2, PoolManager: 3, ... Office Staff: 7)  
    //   e) if the rule doesn't contain any of the things we looked for above then disallow

    if(rule.includes('N;')) return false; //Regardless of anything else if 'N' then disallow
    if(rule.includes('Y;')) return true;  //Regardless of anything else if 'Y' then allow
    if(rule.includes('LT;')) {//Check for signed on ordinance < employee being accessed ordinance
      if(ordinance_SignedOnUser < ordinance_employee) return true;
    }
    if(rule.includes('LE;')) {//Check for signed on ordinance <= employee being accessed ordinance
      if(ordinance_SignedOnUser <= ordinance_employee) return true;
    }
    //If the code above didn't make a determination then be pessimistic and return false
    return false;
  },
  allowActionForElement_P(action,elementIdentifier,pid_employeeOrNull,ordinance_employeeOrNull) {    
    var rule = this.getRule(elementIdentifier,action)
    if(rule.length==0) return false;           //be pessimistic if there is no rule
    var ordinance_employee = ordinance_employeeOrNull;
    var pid_employee = pid_employeeOrNull;
    if(ordinance_employee == null) 
      ordinance_employee = sessionStorage.getItem('employeeBeingViewed_ordinance');
    if(pid_employee == null)
      pid_employee = sessionStorage.getItem('employeeBeingViewed_pid');
    return this.allow_P(rule,pid_employee,ordinance_employee)
  },
  canAdd_P(elementIdentifier,pid_employee,ordinance_employee) {
    return this.allowActionForElement_P("add",elementIdentifier,pid_employee,ordinance_employee)
  },
  canEdit_P(elementIdentifier,pid_employee,ordinance_employee) {
    return this.allowActionForElement_P("edit",elementIdentifier,pid_employee,ordinance_employee)
  },
  canDelete_P(elementIdentifier,pid_employee,ordinance_employee) {
    return this.allowActionForElement_P("delete",elementIdentifier,pid_employee,ordinance_employee)
  },
  canView_P(elementIdentifier,pid_employee=null,ordinance_employee=null) {
    return this.allowActionForElement_P("view",elementIdentifier,pid_employee,ordinance_employee)
  },
  canUpload_P(elementIdentifier,pid_employee,ordinance_employee) {
    return this.allowActionForElement_P("upload",elementIdentifier,pid_employee,ordinance_employee)
  },
  canDownload_P(elementIdentifier,pid_employee,ordinance_employee) {
    return this.allowActionForElement_P("download",elementIdentifier,pid_employee,ordinance_employee)
  },
  //action parm below should be either "add" or "edit"
  //When action is add the employee id passed to this method should be null thus
  //it will be set to -1 and it will not possibly be equal to the id of the signed on user
  //When action is edit the actual id of the person being edited should be passed along.
  //The ordinance value passed along is the ordinance value associated with the position
  //in question.
  disablePositionSelectable_P(action, position, pid_employee=-1) {  
    //When editing we check to see if the signed on user's role ordinance is the same as the
    //position's role ordinance and if so we pass along the signed on users employee id so the
    //"O or !O" security check can be done.  
    var ordinance_SignedOnUser = authDetails.roleOrdinance;
    var pid_employee_passItOn = pid_employee;
    if(action=="edit" && (position.roleOrdinance!=ordinance_SignedOnUser))
      pid_employee_passItOn = -1;
    var disableTheChoice = !this.allowActionForElement_P(action,'personnelposition', pid_employee_passItOn, position.roleOrdinance);
    //alert("xxxSaction: "+action+" / ord: " + position.roleOrdinance + " / pid_employee: " + pid_employee)
    return disableTheChoice
   },
  //If arrayOrSingleString is an array then we use the all param value to make the determination
  //  when all is false (default) then if any elementIdentifier rule is true we allow
  //  when all is true            then if any elementIdentifier rule is false we disallow
  canDisplay_P(arrayOf_orSingle_elementIdentifier,pid_employee,ordinance_employee,all=false) {
    var ordinance_SignedOnUser = authDetails.roleOrdinance;
    var pid_SignedOnUser       = authDetails.PersonnelId;
    if(typeof arrayOf_orSingle_elementIdentifier === 'string') {//checking a single elementIdentifier no need to check the anyOrAll setting
      return this.canView_P(arrayOf_orSingle_elementIdentifier,pid_employee,ordinance_employee)
    }

    for(var i=0;i<arrayOf_orSingle_elementIdentifier.length;i++) {//checking multiple elementIdentifiers
      var canView = this.canView_P(arrayOf_orSingle_elementIdentifier[i],pid_employee,ordinance_employee);
      if(all) {
        if(!canView) return false //AT LEAST ONE elementIdentifier IS NOT allowed
      }
      else {
        if(canView) return true //AT LEAST ONE elementIdentifier IS allowed
      }
    }
    //If the code above could not make a determination (and it should) then be pessimistic and return false
    return false;
  },    
   //In most cases we do not want to show the view button if the edit button is being displayed
  //this method can be used when that is the case.
  //NOTE: it doesn't return a boolean value but rather
  //      'E' for Edit Button
  //      'V' for View Button
  //      'X' for neither button
  showViewOrEditOrNeitherButton_P(elementIdentifier) {
    if(this.canEdit_P(elementIdentifier)) return "E"
    if(this.canView_P(elementIdentifier)) return "V"
    return "X"
  },
  /**************************************************************************************
   * METHODS ABOVE ARE SPECIFIC TO DOING SECURITY CHECKS FOR PERSONELL DATA             *
   **************************************************************************************/

  canDelete_A(elementIdentifier) {
    var rule = this.getRule(elementIdentifier)
    if(rule.length==0) return false;           //be pessimistic if there is no rule
    return rule['delete']=='Y';
  },
  canAdd_A(elementIdentifier) {
    var rule = this.getRule(elementIdentifier)
    if(rule.length==0) return false;           //be pessimistic if there is no rule
    return rule['add']=='Y';
  },
  canEdit_A(elementIdentifier) {
    var rule = this.getRule(elementIdentifier)
    if(rule.length==0) return false;           //be pessimistic if there is no rule
    return rule['edit']=='Y';
  },
  canView_A(elementIdentifier) {
    //if(1==1) return true; //BIG ALLOW HERE... NEED TO REMOVE AFTER TESTING

    var rule = this.getRule(elementIdentifier)
    if(rule.length==0) return false;           //be pessimistic if there is no rule
    var ruleView = rule['view'];
    //FG - FOOF - If the elementIdentifier is "personnel" then anything other than a rule with "N"
    //  will return true.  Subsequent security checks will determine who/what can be seen.
    if(elementIdentifier == "personnel" && ruleView !="N")
        return true;
    return ruleView =='Y'; 
  },
  canUpload_A(elementIdentifier) {
    var rule = this.getRule(elementIdentifier)
    if(rule.length==0) return false;           //be pessimistic if there is no rule
    return rule['upload']=='Y';
  },
  canDownload_A(elementIdentifier) {
    var rule = this.getRule(elementIdentifier)
    if(rule.length==0) return false;           //be pessimistic if there is no rule
    return rule['download']=='Y';
  },
  //NOTE: FOR SAFETY PLAN VIEW IS A BIT OFF BECAUSE WE BASICALLY CAN UPLOAD/DOWNLOAD
  //BUT WE DO LIST THE ELEMENTS IN THE PLAN SO VIEW MUST BE "Y" FOR SAFETY PLAN
  //IF WE ARE TO DISPLAY THAT PAGE
  canDisplay_A(arrayOrSingleString) {    
    if(typeof arrayOrSingleString === 'string')
      return this.canView_A(arrayOrSingleString);
    for(var i=0;i<arrayOrSingleString.length;i++) {
      if(this.canView_A(arrayOrSingleString[i])==true) {
        return true;
      }
    }
    return false;
  },

//The Personnel List needs to show the View Profile button for only the signed on user if
  //all of the sub-"elements" (personnelbasicinfo,personneljobinfo,etc., are O for Own)
  allElementsAre_Own(arrayOrSingleString,pid_employee,ordinance_employee) {
    for(var i=0;i<arrayOrSingleString.length;i++) {
      if(this.canView_A(arrayOrSingleString[i])!=="O") {
        return false;
      }
  }
  return true;
},

  //In most cases we do not want to show the view button if the edit button is being displayed
  //this method can be used when that is the case.
  //NOTE: it doesn't return a boolean value but rather
  //      'E' for Edit Button
  //      'V' for View Button
  //      'X' for neither button
  showViewOrEditOrNeitherButton_A(elementIdentifier) {//alert ("GET RID OF THE 1==1")
    //if(1==1) return "E" 
    if(this.canEdit_A(elementIdentifier)) return "E"
    if(this.canView_A(elementIdentifier)) return "V"
    return "X"
  },
  showViewOrEditOrNeitherButtonCannotEditSelf_A(elementIdentifier,isself) {
    if(this.canEdit_A(elementIdentifier) && !isself) {
      return "E"
    }
    if(this.canView_A(elementIdentifier)) return "V"
    return "X"
  },
  //The method below should be called for forms and or fields that need to know if
  //they should be disabled.
  //It returns true (they should be disabled) if the page is in edit mode and can edit is false
  //It returns true (they should be disabled) if the page is in add mode and can add is false
  //It returns true (they should be disabled) in all other cases
  disableDataEntry_A(elementIdentifier, isEditingOrIsAdding) {
    
    //if(elementIdentifier == "personnelperformance")
    //  alert("in disableDataEntry_A isEditingOrIsAdding: " + isEditingOrIsAdding);
    if(isEditingOrIsAdding == "E") 
      return !this.canEdit_A(elementIdentifier)
    else if (isEditingOrIsAdding == "A") 
      return !this.canAdd_A(elementIdentifier)
    else
      return true;
  },

  //Added method below when the decision was made that one cannot edit some of one's own data
  disableDataEntryForSelf_A(elementIdentifier, isEditingOrIsAdding, isself) {
    if(isEditingOrIsAdding == "E" && !isself) 
      return !this.canEdit_A(elementIdentifier)
    else if (isEditingOrIsAdding == "A") 
      return !this.canAdd_A(elementIdentifier)
    else
      return true;
  }
}




// WEBPACK FOOTER //
// ./src/hydrowareSecurityJS.js